import React from "react";
import Select from "react-select";
//import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { InputLabel } from "@mui/material";

import { Grid  , GridItem, FormLabel, Box, SimpleGrid} from "@chakra-ui/react";

/*const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));*/


export function SelectFiltros(props) {
  const {
    estados,
    destinos,
    setFiltroEstados,
    setFiltroDestinos,
  } = props;

  const customStyles = {
    menuPortal: (provided) => ({ ...provided, zIndex: 9999, width: "300px" }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  return (
    <>
    <SimpleGrid columns={2} spacing={10}>
        <Box height='50px' >
            <FormLabel id="demo-simple-select-label"> Destino </FormLabel>
                <Select
                    isMulti
                    styles={customStyles}
                    name="destino"
                    options={destinos}
                    getOptionLabel={(option) => option.descripcion}
                    getOptionValue={(option) => option.id}
                    onChange={setFiltroDestinos}
                />    
        </Box>
        <Box height='80px'>
            <FormLabel id="demo-simple-select-label"> Estado </FormLabel>
                <Select
                    isMulti
                    name="estado"
                    styles={customStyles}
                    options={estados}
                    getOptionLabel={(option) => option.descripcion}
                    getOptionValue={(option) => option.id}
                    //defaultvalue={filtroestado}
                    onChange={setFiltroEstados}
                />
        </Box>
    </SimpleGrid>    
    </>
  );
}
